import React from "react"
import ApartmentPage from "../../components/molecules/Page/ApartmentPage"
import { GlobalProvider } from "../../GlobalProvider"

export default ({ pageContext }) => (
  <GlobalProvider>
    <ApartmentPage {...pageContext} />
  </GlobalProvider>
)
